import { Node } from "@tiptap/core";
import { mergeAttributes } from "@tiptap/react";
import { A4_HEIGHT, A4_WIDTH, PADDING } from "../constants";

export const PageContainer = Node.create({
    name: "pageContainer",
    group: "block",
    content: "pageHeader contentContainer",

    addAttributes() {
        return {
            "page-number": {
                default: 1,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-type="page-container"]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "page-container",
                style: `width: ${A4_WIDTH}px; height: ${A4_HEIGHT}px; padding: ${PADDING}px;`,
                class: "page-container",
            }),
            0,
        ];
    },
});
